import { render, staticRenderFns } from "./ApplicationSection.vue?vue&type=template&id=06b1b1fc&scoped=true&"
import script from "./ApplicationSection.vue?vue&type=script&lang=js&"
export * from "./ApplicationSection.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSection.vue?vue&type=style&index=0&id=06b1b1fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1b1fc",
  null
  
)

export default component.exports